import React, { useEffect, useState } from "react";
import apiBaseUrl from "../../utils/config";
import officeHoursService from "../office/officeHoursService";
import TooltipInput from "../../NewUPT/ToolTip/TooltipInput";
import TooltipSelect from "../../NewUPT/ToolTip/TooltipSelect";
import "../../NewUPT/registration/searchPopupDesign.css"; // Make sure the path matches your setup

const RegisterOfficeSchedule = () => {
    const [officeId, setOfficeId] = useState("");
    const [officeName, setOfficeName] = useState("");
    const [dayOfWeek, setDayOfWeek] = useState("Monday");
    const [date, setDate] = useState("");
    const [openHour, setOpenHour] = useState("");
    const [closeHour, setCloseHour] = useState("");
    const [increments, setIncrements] = useState("15");

    const officeService = new officeHoursService();

    useEffect(() => {
        const receivePopupMessage = (event) => {
            if (event.data.target === "officeId") {
                setOfficeId(event.data.value);
                setOfficeName(event.data.displayName);
            }
        };
        window.addEventListener("message", receivePopupMessage);
        return () => window.removeEventListener("message", receivePopupMessage);
    }, []);

    const openSearchPopup = () => {
        const url = `${apiBaseUrl}/office/search`;
        window.open(url, "popup", "width=600,height=400");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const day = openHour === "00:00" && closeHour === "00:00" ? "Closed" : dayOfWeek;

        const data = {
            officeId: officeId.trim(),
            dayOfWeek: day,
            date,
            openHour,
            closeHour,
            increments: parseInt(increments, 10),
        };

        if (!data.officeId || !data.date) {
            alert("Please select an office and a valid date.");
            return;
        }

        try {
            const response = await officeService.saveOfficeHours(data);
            alert("Office Schedule Registered Successfully: " + JSON.stringify(response));
        } catch (error) {
            alert("Registration Failed: " + error.message);
        }
    };

    return (
    <div className="form-wrapper">
        <form id="officeScheduleRegistrationForm" onSubmit={handleSubmit}>
            {/* Office Search */}
            <div className="input-container">
                <button type="button" onClick={openSearchPopup}>Search Office</button>
            </div>
            <div className="input-container">
                <input type="text" value={officeName} placeholder="Selected Office" readOnly />
                <input type="hidden" value={officeId} />
            </div>

            {/* Day of Week */}
            <TooltipSelect
                id="dayOfWeek"
                label="Select the day of the week."
                value={dayOfWeek}
                onChange={setDayOfWeek}
                options={["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]}
            />

            {/* Date, Time, Increments */}
            <TooltipInput
                type="date"
                id="date"
                placeholder="Select Date"
                tooltip="Choose a specific date for scheduling."
                value={date}
                onChange={setDate}
            />
            <TooltipInput
                type="time"
                id="openHour"
                placeholder="Select Open Hour"
                tooltip="Opening time for the office."
                value={openHour}
                onChange={setOpenHour}
            />
            <TooltipInput
                type="time"
                id="closeHour"
                placeholder="Select Close Hour"
                tooltip="Closing time for the office."
                value={closeHour}
                onChange={setCloseHour}
            />
            <TooltipSelect
                id="increments"
                label="Select time interval (minutes)."
                value={increments}
                onChange={setIncrements}
                options={["15", "30", "45", "60", "90", "120"]}
                suffix=" mins"
            />

            <button type="submit">Register Office Schedule</button>
        </form>
    </div>
    );
};

export default RegisterOfficeSchedule;
